module.exports = __webpack_public_path__ + "static/media/camera.3c90033c.svg";